<template>
  <section
    v-show="hasMediaReviews"
    :id="`${componentPrefix}-component`"
    class="mx-auto px-2 max-w-screen-xxl mb-6"
    data-ga-dimension="dimension11"
    data-ga-dimension-value="Editorial"
  >
    <pdl-carousel carousel-type="ltr" has-navigation>
      <pdl-carousel-slide v-for="review in mediaReviews" :key="review.id">
        <product-media-review-card :review="review" />
      </pdl-carousel-slide>
    </pdl-carousel>
  </section>
</template>

<script>
import {mapState} from 'vuex';
import ProductMediaReviewCard from '@/components/tabs/overview/ProductMediaReviewCard.vue';
import {PdlCarousel, PdlCarouselSlide} from '@pedal/pdl-carousel';

export default {
  components: {
    ProductMediaReviewCard,
    PdlCarousel,
    PdlCarouselSlide,
  },
  data() {
    return {
      componentPrefix: 'product-media-review',
    };
  },
  computed: {
    ...mapState('productDetails', ['product']),

    hasMediaReviews() {
      return !!(this.product && this.product?.productReviews?.length);
    },

    mediaReviews() {
      return this.product?.productReviews;
    },
  },
};
</script>
